import { render, staticRenderFns } from "./MeasurementUnitList.vue?vue&type=template&id=41428f1d&scoped=true"
import script from "./MeasurementUnitList.vue?vue&type=script&lang=js"
export * from "./MeasurementUnitList.vue?vue&type=script&lang=js"
import style0 from "./MeasurementUnitList.vue?vue&type=style&index=0&id=41428f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41428f1d",
  null
  
)

export default component.exports